import { isOfflineMode } from '@atlaskit/editor-common/connectivity/isOfflineMode';
import type { ExtractInjectionAPI } from '@atlaskit/editor-common/types/next-editor-plugin';
import { useSharedPluginStateWithSelector } from '@atlaskit/editor-common/useSharedPluginStateWithSelector';

import type { AIPlugin } from '../../../aiPluginType';

export const getIsOffline = (api: ExtractInjectionAPI<AIPlugin> | undefined): boolean =>
	isOfflineMode(api?.connectivity?.sharedState?.currentState()?.mode);

export const useIsOffline = (api: ExtractInjectionAPI<AIPlugin> | undefined): boolean => {
	const { isOffline } = useSharedPluginStateWithSelector(
		api,
		['connectivity'],
		({ connectivityState }) => ({
			isOffline: isOfflineMode(connectivityState?.mode),
		}),
	);

	return isOffline;
};
